import(/* webpackMode: "eager" */ "/tmp/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/app/(public)/[sport]/injuries/filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/components/team/injuries-table.tsx");
